import { useState } from 'react';
import { useAppStore } from '@/store/AppStore';
import { SERVICES, REGIONS, EXPENSE_CATEGORIES, PAYMENT_METHODS } from '@/mocks/constants';

export default function Ayarlar() {
  const { teams } = useAppStore();
  const [firmName, setFirmName] = useState('VİAYPİİ TEMİZLİK');
  const [firmPhone, setFirmPhone] = useState('0850 000 00 00');
  const [prefs, setPrefs] = useState({
    yeniTalep: true,
    videoGeldi: true,
    teklifCevap: true,
    randevu: true,
    tahsilat: true,
    haftalikOzet: false,
  });

  function toggle(key: keyof typeof prefs) {
    setPrefs((p) => ({ ...p, [key]: !p[key] }));
  }

  const prefItems: { key: keyof typeof prefs; label: string; desc: string }[] = [
    { key: 'yeniTalep', label: 'Yeni Talep', desc: 'Yeni talep geldiğinde bildir' },
    { key: 'videoGeldi', label: 'Video Geldi', desc: 'Müşteri video gönderdiğinde bildir' },
    { key: 'teklifCevap', label: 'Teklif Cevabı', desc: 'Teklif yanıtı geldiğinde bildir' },
    { key: 'randevu', label: 'Randevu Hatırlatma', desc: 'Yaklaşan randevuları bildir' },
    { key: 'tahsilat', label: 'Tahsilat', desc: 'Bekleyen tahsilatları bildir' },
    { key: 'haftalikOzet', label: 'Haftalık Özet', desc: 'Haftalık finans özeti gönder' },
  ];

  const inputClass =
    'h-10 w-full rounded-md border border-background-200 bg-white px-3 text-sm text-foreground-800 focus:border-primary-400 focus:outline-none';

  return (
    <div className="mx-auto max-w-[1100px] space-y-6">
      <div>
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.14em] text-accent-600">
          <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
          Yönetim
        </div>
        <h1 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">Ayarlar</h1>
        <p className="mt-1 text-sm text-foreground-500">Firma, hizmetler ve tercihler.</p>
      </div>

      {/* Firma */}
      <section className="rounded-lg border border-background-200 bg-white p-5">
        <h2 className="font-heading text-[15px] font-bold text-foreground-950">Firma</h2>
        <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <label className="mb-1.5 block text-xs font-semibold text-foreground-600">Firma Adı</label>
            <input className={inputClass} value={firmName} onChange={(e) => setFirmName(e.target.value)} />
          </div>
          <div>
            <label className="mb-1.5 block text-xs font-semibold text-foreground-600">Telefon</label>
            <input className={inputClass} value={firmPhone} onChange={(e) => setFirmPhone(e.target.value)} />
          </div>
        </div>
      </section>

      {/* Hizmetler & Bölgeler */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <section className="rounded-lg border border-background-200 bg-white p-5">
          <h2 className="font-heading text-[15px] font-bold text-foreground-950">Hizmetler</h2>
          <ul className="mt-4 space-y-2">
            {SERVICES.map((s) => (
              <li key={s} className="flex items-center justify-between rounded-md bg-background-50 px-3 py-2 text-sm text-foreground-700">
                {s}
                <i className="ri-more-2-fill text-foreground-300" />
              </li>
            ))}
          </ul>
        </section>
        <section className="rounded-lg border border-background-200 bg-white p-5">
          <h2 className="font-heading text-[15px] font-bold text-foreground-950">Bölgeler</h2>
          <ul className="mt-4 space-y-2">
            {REGIONS.map((r) => (
              <li key={r} className="flex items-center justify-between rounded-md bg-background-50 px-3 py-2 text-sm text-foreground-700">
                {r}
                <i className="ri-more-2-fill text-foreground-300" />
              </li>
            ))}
          </ul>
        </section>
      </div>

      {/* Ekipler */}
      <section className="rounded-lg border border-background-200 bg-white p-5">
        <h2 className="font-heading text-[15px] font-bold text-foreground-950">Ekipler</h2>
        <ul className="mt-4 space-y-2">
          {teams.map((t) => (
            <li key={t.id} className="flex items-center justify-between rounded-md bg-background-50 px-3 py-2.5">
              <div>
                <span className="text-sm font-semibold text-foreground-900">{t.name}</span>
                <span className="ml-2 text-xs text-foreground-500">{t.members.join(', ')}</span>
              </div>
              <i className="ri-more-2-fill text-foreground-300" />
            </li>
          ))}
        </ul>
      </section>

      {/* Finans */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <section className="rounded-lg border border-background-200 bg-white p-5">
          <h2 className="font-heading text-[15px] font-bold text-foreground-950">Gider Kategorileri</h2>
          <div className="mt-4 flex flex-wrap gap-2">
            {EXPENSE_CATEGORIES.map((c) => (
              <span key={c} className="rounded-full border border-background-200 bg-background-50 px-3 py-1.5 text-sm text-foreground-700">
                {c}
              </span>
            ))}
          </div>
        </section>
        <section className="rounded-lg border border-background-200 bg-white p-5">
          <h2 className="font-heading text-[15px] font-bold text-foreground-950">Ödeme Yöntemleri</h2>
          <div className="mt-4 flex flex-wrap gap-2">
            {PAYMENT_METHODS.map((m) => (
              <span key={m} className="rounded-full border border-background-200 bg-background-50 px-3 py-1.5 text-sm text-foreground-700">
                {m}
              </span>
            ))}
          </div>
        </section>
      </div>

      {/* Bildirim tercihleri */}
      <section className="rounded-lg border border-background-200 bg-white p-5">
        <h2 className="font-heading text-[15px] font-bold text-foreground-950">Bildirim Tercihleri</h2>
        <ul className="mt-4 divide-y divide-background-100">
          {prefItems.map((item) => (
            <li key={item.key} className="flex items-center justify-between py-3">
              <div>
                <div className="text-sm font-semibold text-foreground-900">{item.label}</div>
                <div className="text-xs text-foreground-500">{item.desc}</div>
              </div>
              <button
                type="button"
                onClick={() => toggle(item.key)}
                className={`relative h-6 w-11 rounded-full transition-colors ${prefs[item.key] ? 'bg-primary-500' : 'bg-background-300'}`}
                aria-label={item.label}
              >
                <span
                  className={`absolute top-0.5 h-5 w-5 rounded-full bg-white transition-transform ${prefs[item.key] ? 'translate-x-5' : 'translate-x-0.5'}`}
                />
              </button>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}